import React, { useState, useEffect, useCallback } from 'react';
import { api } from '@/contexts/AuthContext';
import { formatDate } from '@/lib/utils';
import { Check, CheckCheck, Inbox } from 'lucide-react';

export const DWRApprovalInbox = ({ onChanged, onView }) => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    api.get('/dwr?status=SUBMITTED&limit=200').then(r => setItems(r.data.dwrs || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const approve = async (ids) => {
    if (ids.length > 1 && !window.confirm(`Approve all ${ids.length} submitted DWRs?`)) return;
    setBusy(true);
    try {
      if (ids.length === 1) await api.post(`/dwr/${ids[0]}/approve`);
      else await api.post('/dwr/approve-bulk', { ids });
      load();
      onChanged();
    } catch (err) { alert(err.response?.data?.detail || 'Approval failed'); } finally { setBusy(false); }
  };

  return (
    <div className="bg-white rounded-lg border border-slate-200" data-testid="dwr-approval-inbox">
      <div className="flex items-center justify-between gap-3 p-4 border-b border-slate-100">
        <div className="flex items-center gap-2">
          <Inbox size={16} className="text-[#1B5486]" />
          <h3 className="text-sm font-semibold text-slate-900">Approval Inbox</h3>
          <span className="text-xs px-2 py-0.5 rounded-full bg-amber-100 text-amber-700" data-testid="inbox-count">{items.length}</span>
        </div>
        {items.length > 1 && (
          <button onClick={() => approve(items.map(i => i.id))} disabled={busy} data-testid="approve-all-btn"
            className="flex items-center gap-1.5 bg-emerald-600 text-white px-3 py-1.5 rounded-md text-xs font-medium hover:bg-emerald-700 disabled:opacity-50">
            <CheckCheck size={14} /> Approve All
          </button>
        )}
      </div>
      {items.length === 0 ? (
        <div className="text-center py-8 text-sm text-slate-400" data-testid="inbox-empty">Nothing waiting for approval</div>
      ) : (
        <ul className="divide-y divide-slate-100">
          {items.map(d => (
            <li key={d.id} className="flex items-center gap-3 px-4 py-3 hover:bg-slate-50" data-testid={`inbox-item-${d.id}`}>
              <button onClick={() => onView(d.id)} className="flex-1 min-w-0 text-left">
                <div className="text-sm font-medium text-slate-900 truncate">{d.project_code} · {formatDate(d.date)}</div>
                <div className="text-xs text-slate-500 truncate">{d.supervisor_name} · {d.employee_count || 0} workers</div>
              </button>
              <button onClick={() => approve([d.id])} disabled={busy} data-testid={`inbox-approve-${d.id}`}
                className="flex items-center gap-1 px-3 py-1.5 rounded-md border border-emerald-300 text-emerald-700 text-xs font-medium hover:bg-emerald-50 disabled:opacity-50">
                <Check size={14} /> Approve
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
